import styled, { css } from "../../../styled/index";
import { shadeAlternate } from "../../../styled/helpers";
export const Tag = styled("span") `
  display: inline-block;
  font-size: ${({ fontSize }) => fontSize || 12}px;
  font-weight: 600;
  background: ${({ theme, background }) => background || shadeAlternate(0.08, theme.box.background)};
  color: ${({ theme, text }) => text || theme.box.text};
  padding: 5px 5px;
  border-radius: ${({ borderRadius }) => borderRadius ? borderRadius : '3px'};
  ${({ version }) => version === 'v2.1' ? css `
    border-radius: 99px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: fit-content;
    gap: 8px;
  ` : ''}
`;
//# sourceMappingURL=index.js.map